import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useAddAssignmentMutation } from '../../features/assignment/assignmentApi';
import useGetUnUsedVideoId from '../../Hooks/useGetUnUsedVideoId';

const AddAssignment = () => {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { isLoading: isIdsLoading, isError: isIdsError, uniqIdVideos } = useGetUnUsedVideoId()
    const [addAssignment, { isLoading, isError, isSuccess }] = useAddAssignmentMutation()

    const onSubmit = (data) => {

        data.totalMark = parseFloat(data.totalMark)
        if (data.video_id) {
            const videoId = parseInt(data.video_id)
            data.video_id = videoId
            const video_title = uniqIdVideos.find(single => single.id === videoId).title
            data.video_title = video_title
        }

        addAssignment(data)
    };
    useEffect(() => {
        if (isSuccess) {
            navigate('/admin/assignment')
        }
    }, [isSuccess])

    let content = null;
    if (isIdsLoading) {
        content = <div>
            <Loading ></Loading>
        </div>
    }
    else if (isIdsError) {
        content = <div>
            Error while getting ids
        </div>
    }
    else {
        content = <form onSubmit={handleSubmit(onSubmit)}>
            <label htmlFor="title">Title:</label>
            <input className='login-input' type="text" id="title" {...register("title", { required: true })} />
            <label htmlFor="totalMark">Total Mark</label>
            <input type="number" className='login-input' id="totalMark" {...register("totalMark", { required: true })} />

            <label htmlFor="choseID">choose Video</label>
            {
                uniqIdVideos.length ? <select  {...register("video_id", { required: true })} id='choseID' defaultValue={undefined} className='block w-full login-input '>
                    <option value={undefined} hidden >Select video</option>
                    {uniqIdVideos.map(single => <option className='my-2' key={single.id} value={single.id}>{single.title}</option>)}
                </select> :
                    <div className='text-error text-center'>
                        No uniq videos found to add Assignment. No worry you can add letter!
                    </div>
            }

            <button disabled={isLoading} className='mt-5 py-2 px-5 rounded-md border border-blue-500' type="submit">Submit</button>
        </form>
    }

    return (
        <div className='flex justify-center'>
            <div className='w-1/2'>
                {
                    content
                }

            </div>
        </div>
    );
};

export default AddAssignment;